import * as $ from 'jquery';
import 'bootstrap';

export class bannerComponent {
	/**
	 *
	 * find all banner components
	 * if banner component contains a cta button on the image holder,
	 * on click navigate to the href of the anchor element
	 * - implement since image holder component is behind content holder
	 *   and z-index prevents clicking on content-holder to pass through
	 *   to image holder
	 * @return {any} [description]
	 */
	initBannerMobileAnchor(): void {
		let bannerComponent:any = $('.banner-container');
		let _self = this;

		bannerComponent.each(function(){
			let _bannerItem = $(this);
			let mobileImage = _bannerItem.find('.img-holder .mobile-version a');

			_bannerItem.on('click', () => {
				if (window.innerWidth < 768) {
					if (mobileImage.length) {
						window.location = mobileImage[0].getAttribute('href');
					}
				}
			});
		});
	}

	initVideoPlay(): void {
		let $videoContainer:any = $('.video-container video');
		$videoContainer.each(function(){
			let $this = $(this);
			var getVideoID = $this.attr('id');
			let videoComponent:any = document.getElementById(getVideoID);
			let $videoPlay:any = $('.video-container .playpause');
			videoComponent.autoplay = true;
			$('video').on('play', function(e:any){
				$('.video-container .playpause').hide();
			});
			$videoPlay.on('click', function(){
				$('.video-container .playpause').hide();
				videoComponent.play();
			});
		});
	}
}

let scope:Element = document.querySelector('.banner-container');
if (scope){
	try {
		let initbannercarousel = new bannerComponent();
		initbannercarousel.initBannerMobileAnchor();
		initbannercarousel.initVideoPlay();
	} catch(e) {console.error(e);}
}
